import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Transition from '@ember/routing/-private/transition';
import { redirectIfNoPermission } from 'cio/utils/route-access';

import NewSegmentController from 'cio/pods/segments/new/controller';
import FiltersService from 'cio/services/filters';
import DS from 'ember-data';

export default class NewSegmentRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'New',
      path: 'segments.new',
    };
  }

  model({ referenceSegmentId }: { referenceSegmentId: string }) {
    return isEmpty(referenceSegmentId)
      ? this.store.createRecord('segment')
      : this.store.findRecord('segment', referenceSegmentId).then((segment) =>
          this.store.createRecord('segment', {
            ...segment.getProperties('description', 'type', 'conditions'),
            name: `COPY - ${segment.name}`,
          }),
        );
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoPermission(this, 'journeys/segments/create', transition);
  }

  afterModel() {
    return this.filters.process.perform();
  }

  resetController(controller: NewSegmentController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }
}
